"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var easing_1 = require("../helper/easing");
exports.interpolate = function (value, range, easing) {
    var start = range[0], end = range[1];
    var val = value;
    if (easing) {
        val = typeof easing === 'string' ? easing_1.easeValue(value, easing) : easing(value);
    }
    return val * (end - start) + start;
};
//# sourceMappingURL=interpolate.js.map